module.exports = new __parcel__URL__("Rovo-loadingV2.b5f1b3c5.gif").toString();